module.exports = __webpack_public_path__ + "static/media/social_discord.01b1e436.png";